import { Injectable } from "@angular/core";
import { Selector, State } from "@ngxs/store";
import { INgxsFormState } from "../../../model/custom/INgxsFormState";

export class SignInFormStateModel {
	public form: INgxsFormState;
}

@State<SignInFormStateModel>({
	name: "SignInForm",
	defaults: {
		form: {
			model: null,
			dirty: false,
			status: "",
			errors: null,
		},
	},
})
@Injectable()
export class SignInFormState {
	@Selector()
	static form(state: SignInFormStateModel) {
		return state.form;
	}
}
